import { Text } from '@fluentui/react-components';
import { LookupRecordContext, RecordContext } from '@powerportalspro/react';
import {
  LookupEdit,
  Section,
  SectionColumn,
  TextEdit,
} from '@powerportalspro/react-fluent';

// `<LookupRecordContext>` branches off into a nested `<RecordContext>`
// for the record referenced by a lookup column on the parent context.
// The sample renders the full wrapper structure — outer
// `<RecordContext>` on `account`, inner `<LookupRecordContext>` on the
// `primarycontactid` lookup — so the source tab shows exactly the
// pattern a consumer would paste in.
//
// `<LookupEdit columnName="primarycontactid">` lets the user pick a
// contact; once selected, the inner editors below `<LookupRecordContext>`
// bind to that contact's columns and edits flow through the surrounding
// save cascade automatically. Empty lookups render nothing inside the
// inner context (the lazy short-circuit on empty / Guid.Empty), matching
// Blazor's perf pattern.
export function LookupRecordContextMainSample() {
  return (
    <RecordContext table="account" warnOnUnsavedChanges={false}>
      <Section>
        <SectionColumn header={<Text weight="semibold">Account</Text>}>
          <TextEdit columnName="name" />
          <LookupEdit columnName="primarycontactid" />
        </SectionColumn>
        <SectionColumn header={<Text weight="semibold">Primary Contact</Text>}>
          <LookupRecordContext columnName="primarycontactid">
            <TextEdit columnName="firstname" />
            <TextEdit columnName="lastname" />
            <TextEdit columnName="emailaddress1" type="email" />
          </LookupRecordContext>
        </SectionColumn>
      </Section>
    </RecordContext>
  );
}
